// extracted by mini-css-extract-plugin
module.exports = {"page":"MembersPage_page__qf9Rf","wrapper":"MembersPage_wrapper__3i4EC"};